import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ variant = 'default' }) {
  const { i18n, t } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };
  
  const currentLang = i18n.language === 'fr' ? 'FR' : 'EN';
  
  if (variant === 'compact') {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleLanguage}
        className="gap-1 text-slate-400 hover:text-white"
        data-testid="language-switcher"
      >
        <Globe className="w-4 h-4" />
        <span className="text-xs font-medium">{currentLang}</span>
      </Button>
    );
  }
  
  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-slate-500" />
      <select
        value={i18n.language}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className="bg-transparent text-sm border border-slate-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-primary"
        data-testid="language-select"
      >
        <option value="fr">{t('settings.french')}</option>
        <option value="en">{t('settings.english')}</option>
      </select>
    </div>
  );
}
